export default __webpack_public_path__ + "static/media/arcade-closed.be6f3c0e.png";